import React, { useState, useEffect } from "react";
import api from "../../services/api";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { i18n } from "../../translate/i18n";
import { List, ListItem } from "@material-ui/core";
const filterOptions = createFilterOptions({
  trim: true,
});

export default function AddExtraAttendantModal({
  title,
  open,
  onClose,
  ticketId,
}) {
  const [attendants, setAttendants] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (!open || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/users/", {
            params: { searchParam },
          });
          setOptions(data.users);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, open]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data } = await api.get(`/tickets/${ticketId}/attendants`);
        setAttendants(data);
      } catch (err) {
        toastError(err);
      }
    };

    fetchUsers();
  }, [ticketId]);

  const handleClose = () => {
    onClose(null);
    setSearchParam("");
    setAttendants([]);
  };

  const onChangeAttendants = () => {
    setIsUpdating(true);
    api
      .patch(`/tickets/${ticketId}/attendants`, {
        attendants: attendants.map((attendant) => attendant.user.id),
      })
      .then(function (response) {
        toast.success("Atendentes atualizados.");
        setIsUpdating(false);
        handleClose();
      })
      .catch(function (error) {
        toast.error("Erro ao atualizar atendentes.");
        setIsUpdating(false);
        console.log(error);
      });
  };

  const onRemoveAttendants = (current) => {
    if (!current.id) {
      setAttendants(
        attendants.filter(
          (attendant) => attendant?.user?.id != current?.user?.id
        )
      );
      return;
    }

    setIsUpdating(true);

    api
      .patch(`/tickets/${ticketId}/attendants`, {
        attendants: attendants
          .filter((attendant) => attendant.id !== current.id)
          .map((attendant) => attendant.id),
      })
      .then(function (response) {
        toast.success("Atendentes atualizados.");
        setAttendants(
          attendants.filter(
            (attendant) => attendant?.user?.id != current?.user?.id
          )
        );
        setIsUpdating(false);
        // handleClose();
      })
      .catch(function (error) {
        toast.error("Erro ao atualizar atendentes.");
        setIsUpdating(false);
        console.log(error);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent dividers>
        <div>
          {!!attendants.length && (
            <strong>
              <em>Atendentes vinculados:</em>
            </strong>
          )}
          <List>
            {!!attendants.length &&
              attendants.map((attendant, index) => (
                <ListItem key={index}>
                  <Typography variant="body2" gutterBottom>
                    {attendant?.user?.name}
                    <IconButton
                      size="small"
                      onClick={(_) => onRemoveAttendants(attendant)}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  </Typography>
                </ListItem>
              ))}
          </List>
          <Autocomplete
            style={{ width: 300 }}
            getOptionLabel={(option) => `${option.name}`}
            onChange={(e, attendant) => {
              if (attendant) {
                setAttendants([
                  ...attendants.filter((current) => current.id !== attendant),
                  { user: attendant },
                ]);
              }
            }}
            options={options}
            filterOptions={filterOptions}
            freeSolo
            autoHighlight
            noOptionsText={i18n.t("transferTicketModal.noOptions")}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label={i18n.t("transferTicketModal.fieldLabel")}
                variant="outlined"
                required
                autoFocus
                onChange={(e) => setSearchParam(e.target.value)}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="default">
          {i18n.t("confirmationModal.buttons.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={() => onChangeAttendants()}
          color="secondary"
        >
          {isUpdating && (
            <CircularProgress
              size={24}
              sx={{
                color: "inherit",
                position: "absolute",
                top: "-50%",
                left: "-50%",
              }}
            />
          )}
          <span style={{ display: isUpdating ? "none" : "inline-block" }}>
            {i18n.t("confirmationModal.buttons.confirm")}
          </span>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
